import { Button, Typography } from '@mui/material';
import { Plus } from '@phosphor-icons/react';
import { HeaderContainer } from '../dashboard/AgentInfoHeader';

interface BrandManagmentHeaderProps {
  selectedTab: number;
  onAddClick: () => void;
}

const BrandManagmentHeader = ({ onAddClick }: BrandManagmentHeaderProps) => {
  return (
    <HeaderContainer>
      <Typography
        sx={{
          fontFamily: 'DM Sans',
          fontWeight: 600,
          fontSize: '24px',
          lineHeight: '100%',
          letterSpacing: '-0.01em',
          color: '#2B2D3F',
        }}
      >
        Brand Management
      </Typography>

      <Button
        variant="contained"
        startIcon={<Plus weight="bold" />}
        sx={{
          textTransform: 'none',
          borderRadius: '6px',
          height: '34px',
          bgcolor: '#5A4CE6',
          color: '#FFFFFF',
          boxShadow: 'none',
        }}
        onClick={onAddClick}
      >
        Add Brand
      </Button>
    </HeaderContainer>
  );
};

export default BrandManagmentHeader;
